import { render } from "./SubNavbar.vue?vue&type=template&id=168f31a8&scoped=true&ts=true&lang=pug"
import script from "./SubNavbar.vue?vue&type=script&lang=ts"
export * from "./SubNavbar.vue?vue&type=script&lang=ts"

import "./SubNavbar.vue?vue&type=style&index=0&id=168f31a8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168f31a8"]])

export default __exports__